import adminSideMenu1 from "./admin1";
import cfApprovalV2 from "./cfApprovalV2";
import { combineReducers } from "redux";

export const reducer = combineReducers({
  adminSideMenu1,
  cfApprovalV2,
});
